import { useState } from 'react';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';
import { Link } from 'react-router-dom';

export default function LatestUpdates() {
  const [activeTab, setActiveTab] = useState('all');
  const tabs = [
    { key: 'all', label: '全部' },
    { key: 'romance', label: '恋爱' },
    { key: 'fantasy', label: '奇幻' },
    { key: 'action', label: '动作' },
    { key: 'thriller', label: '悬疑' },
    { key: 'drama', label: '剧情' },
  ];

  const filteredComics = activeTab === 'all'
    ? comics.sort((a, b) => b.updateDate.localeCompare(a.updateDate)).slice(0, 12)
    : comics.filter((c) => c.category === activeTab).sort((a, b) => b.updateDate.localeCompare(a.updateDate)).slice(0, 12);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              最近更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">最新上架漫画，实时同步更新</p>
          </div>
          <Link
            to="/category/completed"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="flex flex-wrap items-center gap-2 mb-8">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeTab === tab.key
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {filteredComics.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
            {filteredComics.map((comic) => (
              <ComicCard key={comic.id} comic={comic} />
            ))}
          </div>
        ) : (
          <div className="text-center py-16 text-foreground-400">
            <i className="ri-inbox-line text-4xl block mb-3"></i>
            <p>该分类暂无漫画</p>
          </div>
        )}

        <div className="text-center mt-8 sm:hidden">
          <Link
            to="/category/completed"
            className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium whitespace-nowrap"
          >
            查看全部更新 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}